//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import upperCase from 'lodash/upperCase'
import Illustration from '@/components/svg/Illustration'
import isEmpty from 'lodash/isEmpty'
import { findFaqSection, firstFaqSection } from '@/assets/js/faq'

export default {
  components: {
    Illustration
  },
  data() {
    return {
      cases: [],
      sectionTitle: '',
      sectionSlug: '',
      activeIndex: null
    }
  },
  async fetch() {
    try {
      const { status_code, error, result } = await this.$api.getFaq({
        lang: this.$i18n.locale,
        type: this.$route.params.type || 'flight',
        sectionSlug: this.$route.params.section
      })

      if (status_code === 200 && !error && result) {
        const { section: sectionSlug } = this.$route.params

        // Two different questions. A URL that named a section can be wrong
        // about it — an unknown slug makes v2 answer with every group, so
        // rendering groups[0] would put an arbitrary section under a stale
        // address. The category landing names nothing and simply opens on the
        // first published section.
        const section = sectionSlug
          ? findFaqSection(result, sectionSlug)
          : firstFaqSection(result)

        // Only a named slug can be stale, so only a named slug earns a
        // redirect: the landing has nowhere to go but the page it is already
        // on, and sending it there loops. An empty category falls through to
        // the not-available state instead.
        //
        // Live links, not just stale bookmarks — search still emits slugs the
        // published set may not carry. 302 rather than 301 because those slugs
        // come back if the knowledge base republishes them.
        if (!section) {
          if (sectionSlug) this.redirectToCategory()

          return
        }

        this.cases = (section.cases || []).filter(Boolean)
        this.sectionTitle = section.name || ''
        this.sectionSlug = section.slug || ''
      } else throw error
    } catch (e) {
      this.$nuxt.context.error(e)
    }
  },
  computed: {
    faqCategoryPath() {
      // Trailing slash stripped: `help-type` is an empty-path child, so
      // localePath resolves it to /en/help/flight/ while every link to that
      // page elsewhere emits /en/help/flight. Redirecting to the other one
      // would land visitors on a duplicate of a canonical URL.
      return this.localePath({
        name: 'help-type',
        params: { type: this.$route.params.type || 'flight' }
      }).replace(/\/$/, '')
    },
    isEmpty() {
      return isEmpty(this.cases)
    }
  },
  watch: {
    // The header used to be set from a `title` prop, but no route under
    // pages/help passes one, so the mobile app bar rendered blank. The name of
    // the section actually fetched is the title. Guarded on browserType
    // because desktop section.vue `extends` this component and would otherwise
    // commit mobile app-bar config on every render.
    sectionTitle: {
      handler(title) {
        if (this.$store.state.app.browserType !== 'mobile') return

        this.$store.commit('header/SET_HEADER_CONFIG', {
          title: upperCase(title)
        })
      },
      immediate: true
    }
  },
  methods: {
    // context.redirect only reaches the response on the server: on the client,
    // fetch() runs in beforeMount — after the transition is confirmed — and
    // Nuxt's router hook has already called next(), so the redirect is dropped
    // and the visitor is left on the dead end this exists to avoid.
    redirectToCategory() {
      if (process.client) {
        this.$router.replace(this.faqCategoryPath)

        return
      }

      this.$nuxt.context.redirect(302, this.faqCategoryPath)
    }
  }
}
